window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.OrderInvoice.init());

Sq.Shop.OrderInvoice = {
  utils: Sq.Shop.Utils,

  init() {
    if ($('#download-invoice-link').length > 0) {
      this.$el = $('#download-invoice-link');
      this.defaultText = this.$el.attr('data-default-text');
      this.disabledText = this.$el.attr('data-disabled-text');
      this.$el.text(this.defaultText);
      this.bindEvents();
    }
  },

  bindEvents() {
    this.$el.on('click', (e) => {
      e.preventDefault();

      if (this.downloadTimer) {
        return;
      }
      this.toggleDownloadLink(true);

      fetch(this.$el.attr('href'))
        .then((response) => {
          if (!response.ok) {
            throw response;
          }
          return response.blob();
        })
        .then((r) => this.downloadPdf(r))
        .catch((r) => this.flashErrorMessage(r))
        .finally(() => this.toggleDownloadLink(false));
    });
  },

  toggleDownloadLink(disable) {
    if (disable) {
      this.$el.addClass('disabled').text(this.disabledText);
      // TODO(bmizuno): Adjust timeout duration after testing time for actual templates
      this.downloadTimer = setTimeout(
        () => this.toggleDownloadLink(false),
        10000
      );
    } else {
      clearTimeout(this.downloadTimer);
      delete this.downloadTimer;
      this.$el.removeClass('disabled').text(this.defaultText);
    }
  },

  downloadPdf(data) {
    const filePrefix = this.$el.attr('data-file-prefix');
    const orderNumber = this.$el.attr('data-order-number');
    const filename = `${filePrefix}_${orderNumber}.pdf`;

    this.utils.downloadFile(data, filename);
  },

  flashErrorMessage(response) {
    response.json().then((data) => {
      this.utils.flashBanner().update({
        message: data.message,
        state: 'error',
        timeout: 5000,
      });
    });
  },
};
